module.exports = __webpack_public_path__ + "img/info.09a64a34.svg";